import { UIText2 } from '@cian/ui-kit';

import { FC, JSX, MouseEvent as ReactMouseEvent } from 'react';

import styles from './NarrowCardMoreControlsItem.css';

type NarrowCardMoreControlsItemProps = {
  title: string;
  icon: JSX.Element;
  onClick(event: ReactMouseEvent<HTMLElement>): void;
};

// TODO: подумать об использовании button для того, чтобы сделать компонент доступным
export const NarrowCardMoreControlsItem: FC<NarrowCardMoreControlsItemProps> = props => {
  const { icon, onClick, title } = props;

  return (
    <div className={styles['container']} onClick={onClick}>
      {icon}
      <UIText2>{title}</UIText2>
    </div>
  );
};
